<script lang="ts">
  interface Props {
    course_progress: CourseProgressType
  }

  let { course_progress }: Props = $props()

  const url = window.location.href
  const onboarding = url.match("plan_onboarding")
</script>

{#if course_progress.substep === 1}
  <p class="text-center text-3xl font-bold">1.1 Welcome</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      Welcome to <strong>E1: Creating Your One Page Alignment Plan.</strong>
      I am Marc Koehler and I am your instructor. The primary objective is to help
      you develop a One Page Alignment Plan that gets everyone 100% aligned and engaged.
    </p>

    <p class="mt-6 text-lg">
      Follow the instructions for each step, watching the videos and reviewing
      the downloadable resources. Click on the <strong>Download Assets</strong>
      button to access the resources.
      {#if onboarding}
        Clicking <strong>Next</strong> in the top navigation bar helps you track
        your progress and move to the next section.
      {:else}
        Clicking <strong>Complete & Continue</strong> below each module helps you
        track your progress and move to the next section.
      {/if}
      Enjoy the journey!
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083238"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 2}
  <p class="text-center text-3xl font-bold">1.2 Course Overview</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I provide a detailed overview of each of the six weeks reviewing the
      course syllabus (click the Download Assets button to access) and
      associated learning objectives. I review the expectations that will help
      you develop a great One Page Alignment Plan.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083273"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 3}
  <p class="text-center text-3xl font-bold">1.3 The Lead With Purpose Story</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I take you through my 35+ year leadership journey from US Nuclear
      Submarine Officer to Fortune 100 Manager to Turnaround CEO for struggling
      businesses. This gives you deeper insights into the creation of the One
      Page Alignment Plan and formation of Fast Attack Leadership Courses.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083297"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 4}
  <p class="text-center text-3xl font-bold">1.4 Leadership Challenges</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I take you through the top five challenges everyone faces living in a
      complex and dynamically changing world and the impact this is having on
      both employees and leaders.
    </p>
    <p class="mt-6 text-lg">
      I share with you how a One Page Alignment Plan helps you as the leader
      create an engaged team that is empowered to make decisions.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083345"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 5}
  <p class="text-center text-3xl font-bold">1.5 Business Concepts</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I teach you our definition of leadership and management. I take you
      through the seven different components that make up the One Page Alignment
      Plan showing you how they all link together.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083387"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 6}
  <p class="text-center text-3xl font-bold">1.6 Technology Setup</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      In this section, I share with you the technology you can leverage to keep
      your One Page Alignment Plan with you where ever you go. After watching
      the video, download the Lead With Purpose mobile app and print out your
      plan.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083427"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 7}
  <p class="text-center text-3xl font-bold">1.7 Wrap Up</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      This is a recap of the first module. I ask you to reflect upon this
      module's lessons and capture your key takeaways and action items. I end
      with an overview of Module 2 where you will work on your company's Brand
      Purpose.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284083469"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{/if}
